export const ThemeToggleTestIds = {
  ROOT: 'header.theme-toggle',
  LIGHT: 'header.theme-toggle.light',
  DARK: 'header.theme-toggle.dark',
};
